import { render } from "./GameButton.vue?vue&type=template&id=f3c88c18"
import script from "./GameButton.vue?vue&type=script&lang=js"
export * from "./GameButton.vue?vue&type=script&lang=js"

import "./GameButton.vue?vue&type=style&index=0&id=f3c88c18&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/GameButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f3c88c18"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f3c88c18', __exports__)) {
    api.reload('f3c88c18', __exports__)
  }
  
  module.hot.accept("./GameButton.vue?vue&type=template&id=f3c88c18", () => {
    api.rerender('f3c88c18', render)
  })

}


export default __exports__